import {
  phiAccessControl,
  phiAccessControlCheckAccess,
  PhiAccessControlCreateBodyParams,
} from '@fireflyhealth/api'
import { useSelector } from 'react-redux'
import { useMutation, useQuery } from '~/shared/hooks/query'
import { required } from '~/shared/lib/required'
const usePHIAccessCheck = (patientId: number | null) => {
  const me = useSelector(state => state.me)

  const pHIAccessQuery = useQuery(
    patientId != null
      ? phiAccessControlCheckAccess.retrieveQueryKey({ user_id: patientId })
      : ['retrievePhiAccessControlCheckAccess', null],
    async () => {
      const response = await phiAccessControlCheckAccess.retrieve({
        params: { user_id: required(patientId, 'a patient id') },
      })
      return response.data
    },
    {
      enabled: !!patientId && !!me.id,
      staleTime: 12 * 60 * 60 * 1000, // 12 hours
      refetchOnMount: 'always', // access can expire server-side — always re-check on mount
    },
    {
      error: `Unable to check access for patient ${patientId}`,
    },
  )

  const grantPHIAccessMutation = useMutation(
    async (access_reason: PhiAccessControlCreateBodyParams['access_reason']) => {
      const response = await phiAccessControl.create({
        data: { user_id: required(patientId, 'a patient id'), access_reason },
      })
      return response.data
    },
    {},
    { error: 'Unable to grant PHI access' },
  )

  return { pHIAccessQuery, grantPHIAccessMutation }
}

export default usePHIAccessCheck
